import React from 'react';
import { motion } from 'framer-motion';
import { FaGlobe, FaMapMarkerAlt, FaStar } from 'react-icons/fa';

const Header = ({ activeTab, setActiveTab }) => {
  return (
    <motion.header 
      className="glass-header px-6 py-4"
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-8">
          <div className="flex items-center space-x-2">
            <FaGlobe className="text-2xl text-blue-600" />
            <h1 className="text-2xl font-bold text-gray-800">Weather World</h1>
          </div>
          
          <nav className="flex items-center space-x-6">
            <button
              onClick={() => setActiveTab('weather')}
              className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-all duration-200 ${
                activeTab === 'weather'
                  ? 'bg-white/30 text-gray-800'
                  : 'text-gray-600 hover:bg-white/20'
              }`}
            >
              <FaMapMarkerAlt className="text-lg" />
              <span className="font-medium">weather</span>
            </button>
            
            <button
              onClick={() => setActiveTab('favorites')}
              className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-all duration-200 ${
                activeTab === 'favorites'
                  ? 'bg-white/30 text-gray-800'
                  : 'text-gray-600 hover:bg-white/20'
              }`}
            >
              <FaStar className="text-lg" />
              <span className="font-medium">Favorites</span>
            </button>
          </nav>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;
